import { render } from "./CorsoDetail.vue?vue&type=template&id=4dd1a36a"
import script from "./CorsoDetail.vue?vue&type=script&lang=js"
export * from "./CorsoDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__